import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoint } from './endpoints';
import { AccessPerson } from 'app/components/access-panel/shared/types';
import { ApiResponse, LoadOptions, Value } from 'app/types-shared';
import { roleOptions } from 'app/area/administration/edit/endpoints';
import { DefaultRoleDto } from 'app/area/administration/shared/types';
import { SearchApiResponse } from 'app/area/administration/list/types';

export const sharedApi = {

  deleteUser: async (id: number) => {
    return await new RemoteAdminData(endpoint.user)
      .resource<ApiResponse<any>>()
      .withId(id)
      .httpDelete(id);
  },

  deleteMergeUser: async (id: number, reassignReferencesToUser: number) => {
    return await new RemoteAdminData(endpoint.user)
      .resource<ApiResponse<any>>()
      .filter({ reassignReferencesToUser })
      .withId(id)
      .httpDelete(id);
  },

  deleteRole: async (id: number) => {
    return await new RemoteAdminData(endpoint.role)
      .resource<ApiResponse<any>>()
      .withId(id)
      .httpDelete(id);
  },

  userAccess: async (id: number) => {
    const response = await new RemoteAdminData(endpoint.userAccess)
      .resource<ApiResponse<AccessPerson[]>>()
      .filter({ id })
      .single();

    return response.data;
  },

  roleAccess: async (id: number) => {
    const response = await new RemoteAdminData(endpoint.roleAccess)
      .resource<ApiResponse<AccessPerson[]>>()
      .filter({ id })
      .single();

    return response.data;
  },

  getDefaultRole: async () => {
    const response = await new RemoteAdminData(roleOptions.defaultRole)
      .resource<ApiResponse<DefaultRoleDto>>()
      .single();
    return response.data;
  },

  setDefaultRole: async (defaultRole: DefaultRoleDto) => {
    const response = await new RemoteAdminData(roleOptions.defaultRole)
      .resource<ApiResponse<DefaultRoleDto>>()
      .save(defaultRole);
    return response.data;
  },

  getRoles: async () => {
    const response = await new RemoteAdminData(endpoint.userRoleAllOptions)
      .resource<ApiResponse<Value[]>>()
      .single();
    return response.data;
  },

  getUsers: async (loadOptionsParams: LoadOptions) => {
    const response: any = await new RemoteAdminData(endpoint.users)
      .resource<ApiResponse<SearchApiResponse>>()
      .create(loadOptionsParams, false);

    return await response.json();
  }
};
